import { createTheme } from "@mui/material/styles";

export const defaultThemePalette = createTheme({
  palette: {
    primary: {
      main: "#053462",
      dark: "#042C53",
    },
    secondary: {
      main: "#03A9F5",
      dark: "#0288D1",
    },
    background: {
      default: "#fff",
    },
    backgroundContrast: {
      main: "#f4f6f8",
    },
    lightContrast: {
      main: "#919EAB",
    },
    action: {
      active: "#637381",
    },
    error: {
      main: "#FF5630",
      dark: "#B71D18",
      light: "#FFE9D5",
      lighter: "#FFE9D5",
      darker: "#7A0916",
      contrastText: "#fff",
    },
    warning: {
      main: "#FFAB00",
      light: "#FFAB00",
      dark: "#B76E00",
      lighter: "#FFF5CC",
      darker: "#7A4100",
      contrastText: "#212B36",
    },
    info: {
      main: "#00B8D9",
      dark: "#006C9C",
      lighter: "#CAFDF5",
      contrastText: "#FFFFFF",
      darker: "#003768",
    },
    success: {
      main: "#36B37E",
      light: "#00AB5529",
      dark: "#1B806A",
      lighter: "#D8FBDE",
      darker: "#0A5554",
      contrastText: "#FFFFFF",
    },
    text: {
      primary: "#212B36",
      secondary: "#637381",
      disabled: "#919EAB",
    },
    outlineInput: {
      main: "#919EAB52",
    },
    ordersBoard: {
      main: "#F9FAFB",
    },
    divider: "#919EAB3D",
    grey: {
      100: "#F9FAFB",
      300: "#DFE3E8",
      800: "#212B36",
    },
    shaddow: {
      main: "#919EAB33",
    },
  },
});
